// Enumerations
export const TypeEnum = {
    OOP: 0,
    INT: 1,
    STR: 2,
    FLOAT: 3,
    BOOLEAN: 4,
    LIST_INT: 5,
    LIST_STR: 6,
    LIST_FLOAT: 7,
    LIST_BOOLEAN: 8,
    LIST_LIST_INT: 9,
    LIST_LIST_STR: 10,
    LIST_LIST_FLOAT: 11,
    LIST_LIST_BOOLEAN: 12,
    LISTNODE: 13,
    LISTRANDOMNODE: 14,
    BINARYNODE: 15,
    NOTSUPPORTED: -1,
};

// Helper classes and functions
export class ListNode {
    constructor(val = 0, next = null) {
        this.val = val;
        this.next = next;
    }
}

export const createListNode = (array) => {
    if (!Array.isArray(array) || array.length === 0) return null;

    let head = new ListNode(array[0]);
    let current = head;

    for (let i = 1; i < array.length; i++) {
        current.next = new ListNode(array[i]);
        current = current.next;
    }
    return head;
};

export class RandomNode {
    constructor(val = 0, next = null, random = null) {
        this.val = val;
        this.next = next;
        this.random = random;
    }
}

export const createRandomNode = (array) => {
    if (!Array.isArray(array) || array.length === 0) return null;
    const nodes = array.map(([val]) => new RandomNode(val));
    for (let i = 0; i < array.length; i++) {
        const [_, nextIndex, randomIndex] = array[i];
        if (nextIndex !== null && nextIndex < nodes.length) {
            nodes[i].next = nodes[nextIndex];
        }
        if (randomIndex !== null && randomIndex < nodes.length) {
            nodes[i].random = nodes[randomIndex];
        }
    }
    return nodes[0];
};

export class BinaryNode {
    constructor(val = 0, left = null, right = null) {
        this.val = val;
        this.left = left;
        this.right = right;
    }
}

export const createBinaryTree = (array) => {
    if (!Array.isArray(array) || array.length === 0) return null;

    const nodes = array.map((val) => (val !== null ? new BinaryNode(val) : null));

    for (let i = 0; i < array.length; i++) {
        if (nodes[i] !== null) {
            const leftIndex = 2 * i + 1;
            const rightIndex = 2 * i + 2;

            if (leftIndex < array.length) {
                nodes[i].left = nodes[leftIndex];
            }
            if (rightIndex < array.length) {
                nodes[i].right = nodes[rightIndex];
            }
        }
    }

    return nodes[0];
};

// convert individual input values into desired data types
export const check_and_convert = (types, input) => {
    switch (types) {
        case TypeEnum.INT:
            return parseInt(input, 10);
        case TypeEnum.STR:
            return String(input);
        case TypeEnum.FLOAT:
            return parseFloat(input);
        case TypeEnum.BOOLEAN:
            return Boolean(input);
        case TypeEnum.LIST_INT:
            return input.map((x) => parseInt(x, 10));
        case TypeEnum.LIST_STR:
            return input.map((x) => String(x));
        case TypeEnum.LIST_FLOAT:
            return input.map((x) => parseFloat(x));
        case TypeEnum.LIST_BOOLEAN:
            return input.map((x) => Boolean(x));
        case TypeEnum.LIST_LIST_INT:
            return input.map((list) => list.map((x) => parseInt(x, 10)));
        case TypeEnum.LIST_LIST_STR:
            return input.map((list) => list.map((x) => String(x)));
        case TypeEnum.LIST_LIST_FLOAT:
            return input.map((list) => list.map((x) => parseFloat(x)));
        case TypeEnum.LIST_LIST_BOOLEAN:
            return input.map((list) => list.map((x) => Boolean(x)));
        case TypeEnum.LISTNODE:
            return createListNode(input);
        case TypeEnum.LISTRANDOMNODE:
            return createRandomNode(input);
        case TypeEnum.BINARYNODE:
            return createBinaryTree(input);
        default:
            console.error("Unsupported type.");
            return TypeEnum.NOTSUPPORTED;
    }
};

// From input types, convert input values into desired data types
export const check_and_convert_all = (test_case_input_types, test_case_input) => {
    const convertedInputs = {};

    if (test_case_input_types.length !== Object.keys(test_case_input).length) {
        return null;
    }

    Object.keys(test_case_input).forEach((key, index) => {
        const type = test_case_input_types[index];
        const input = test_case_input[key];
        convertedInputs[key] = check_and_convert(type, input);
    });

    return convertedInputs;
};

export const getDataStructureDefinitions = (testCaseInputTypes, testCase) => {
    const definitions = new Set();
    for (let j = 0; j < testCaseInputTypes.length; j++) {
        const inputType = testCaseInputTypes[j];
        console.log("testCase",testCase);        
        const variableName = Object.keys(testCase)[j]
        console.log("variableName",variableName);
        const inputValue = testCase[variableName];
        console.log("inputValue",inputValue);
        switch (inputType) {
            case '1':
                    break;
            case '13':
                definitions.add(`
class ListNode:
    def __init__(self, val=0, next=None):
        self.val = val
        self.next = next

    def __str__(self):
        # Collect all node values into a list for printing.
        values = []
        current = self
        while current:
            values.append(str(current.val))
            current = current.next
        # Return them in a "list-like" string, e.g. "[1, 2, 3]"
        return "[" + ", ".join(values) + "]"

def create_list_node(array):
    if not isinstance(array, list) or len(array) == 0:
        return None
    head = ListNode(array[0])
    current = head
    for val in array[1:]:
        current.next = ListNode(val)
        current = current.next
    return head

${variableName} = create_list_node(${inputValue})`);
                        break;
    
                    case '14': // Random Node
                        definitions.add(`
class RandomNode:
    def __init__(self, val=0, next=None, random=None):
        self.val = val
        self.next = next
        self.random = random

    def __str__(self):
        current = self
        nodes_str = []
        while current:
            # If there's a random pointer, capture the value; otherwise None
            random_val = current.random.val if current.random else None
            nodes_str.append(f"{current.val}(rand={random_val})")
            current = current.next

        return "[" + " -> ".join(nodes_str) + "]"

def create_random_node(array):
    if not isinstance(array, list) or len(array) == 0:
        return None
    # Placeholder: Implement logic for random pointer initialization
    return None

${variableName} = create_random_node(${inputValue})`);
                        break;
    
                    case '15': // Binary Tree
                        definitions.add(`
class BinaryNode:
    def __init__(self, val=0, left=None, right=None):
        self.val = val
        self.left = left
        self.right = right

    def __str__(self):
        def recurse(node):
            if not node:
                return "None"
            left_str = recurse(node.left)
            right_str = recurse(node.right)
            return f"[{node.val}, {left_str}, {right_str}]"

        return recurse(self)

def create_binary_tree(array):
    if not isinstance(array, list) or len(array) == 0:
        return None
    # Placeholder: Implement binary tree construction logic
    return None

${variableName} = create_binary_tree(${inputValue})`);
                        break;
    
                    default:
                        console.warn(`Unsupported input type: ${inputType}`);
                        break;
                }
    }
    return Array.from(definitions).join("\n");
};

export const createListNodeJava = (array) => {
    // Returns a string with Java code to create a linked list from an array
    if (!Array.isArray(array) || array.length === 0) return null;
    let code = `ListNode head = new ListNode(${array[0]});\nListNode current = head;`;
    for (let i = 1; i < array.length; i++) {
        code += `\ncurrent.next = new ListNode(${array[i]});\ncurrent = current.next;`;
    }
    return code;
};

export const createRandomNodeJava = (array) => {
    // Returns a string with Java code to create a random linked list from an array of tuples/arrays.
    // Implementation can be expanded based on your requirements.
    return `// Java code to create random linked list from ${JSON.stringify(array)}`;
};

export const createBinaryTreeJava = (array) => {
    // Returns a string with Java code to create a binary tree from an array
    return `// Java code to create binary tree from ${JSON.stringify(array)}`;
};

// New helper functions for C++
export const createListNodeCpp = (array) => {
    // Returns a string with C++ code to create a linked list from an array
    if (!Array.isArray(array) || array.length === 0) return null;
    let code = `ListNode* head = new ListNode(${array[0]});\nListNode* current = head;`;
    for (let i = 1; i < array.length; i++) {
        code += `\ncurrent->next = new ListNode(${array[i]});\ncurrent = current->next;`;
    }
    return code;
};

export const createRandomNodeCpp = (array) => {
    // Returns a string with C++ code to create a random linked list from an array of tuples/arrays.
    return `// C++ code to create random linked list from ${JSON.stringify(array)}`;
};

export const createBinaryTreeCpp = (array) => {
    // Returns a string with C++ code to create a binary tree from an array
    return `// C++ code to create binary tree from ${JSON.stringify(array)}`;
};

// Updated getCreationFunctions to support multiple languages
export const getCreationFunctions = (testCases, testCaseInputTypes, language = 'python') => {    
    const funcs = [];
    const inputTypes = testCaseInputTypes;
    for (let i = 0; i < inputTypes.length; i++) {
        const value = Object.values(testCases)[i];
        switch (inputTypes[i]) {
            case '13':
                if (language === 'python') {
                    funcs.push(`create_list_node(${value})`);
                } else if (language === 'java') {
                    funcs.push(`createListNodeJava(${value})`);
                } else if (language === 'cpp' || language === 'c++') {
                    funcs.push(`createListNodeCpp(${value})`);
                }
                break;
            case '14':
                if (language === 'python') {
                    funcs.push(`create_random_node(${value})`);
                } else if (language === 'java') {
                    funcs.push(`createRandomNodeJava(${value})`);
                } else if (language === 'cpp' || language === 'c++') {
                    funcs.push(`createRandomNodeCpp(${value})`);
                }
                break;
            case '15':
                if (language === 'python') {
                    funcs.push(`create_binary_tree(${value})`);
                } else if (language === 'java') {
                    funcs.push(`createBinaryTreeJava(${value})`);
                } else if (language === 'cpp' || language === 'c++') {
                    funcs.push(`createBinaryTreeCpp(${value})`);
                }
                break;
            default:
                funcs.push(value);
                break;
        }
    }
    return funcs.join(", ");
};